<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "associatedFeeSection",
  data() {
    return {
      activeNames: ["1"],
      isSelectedPropertyTypeApartmentsUnitsHouseOrTownhouse: "",
      isSelectedPropertyTypeHouseAndLand: "",
      isSelectedPropertyTypeLandOnly: "",
      apartment: "Apartments",
      townhouse: "Townhouses",
      house: "House",
      houseLand: "House & Land",
      landOnly: "Land",
      list: [],
      showReserve: true,
      pm: {},
      loading: true
    };
  },
  props: {
    propsData: Array,
    propsProerty: String
  },
  created() {
    var that = this;

    that.pm = that.$route.params;
    that.getLst({
      params: {
        propertyId: this.$router.currentRoute.query.pid,
        orderByKeyword: "apt",
        ascOrdesc: "asc"
      },
      callback: that.callback
    });
  },
  methods: {
    ...mapActions("price", ["getLst"]),
    ...mapMutations("login", ["cleartime"]),
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toReserve() {
      console.log("This came to reserve");
      // this.$router.push({path: `/property/selection/${this.pm.id}`})
    },
    unfold(i) {
      var that = this;
      that.list[i].unfold = !that.list[i].unfold;
    },
    callback(res) {
      var that = this;
      that.loading = false;
      if (res.data.code == 0) {
        res.data.data.forEach(v => {
          v.unfold = false;
          if (
            v.revisedPrice !== undefined &&
            JSON.stringify(v.revisedPrice).indexOf(".") !== -1
          ) {
            v.revisedPrice = that.$box.formatSplit(v.revisedPrice, true);
          } else {
            v.revisedPrice = that.$box.formatSplit(v.revisedPrice, true);
          }

          if (
            v.landPrice !== undefined &&
            JSON.stringify(v.landPrice).indexOf(".") !== -1
          ) {
            v.landPrice = that.$box.formatSplit(v.landPrice, true);
          } else {
            v.landPrice = that.$box.formatSplit(v.landPrice, true);
          }

          if (
            v.buildingPrice !== undefined &&
            JSON.stringify(v.buildingPrice).indexOf(".") !== -1
          ) {
            v.buildingPrice = that.$box.formatSplit(v.buildingPrice, true);
          } else {
            v.buildingPrice = that.$box.formatSplit(v.buildingPrice, true);
          }
          if (
            v.revisedPriceMax !== undefined &&
            JSON.stringify(v.revisedPriceMax).indexOf(".") !== -1
          ) {
            v.revisedPriceMax = that.$box.formatSplit(v.revisedPriceMax, true);
          } else {
            v.revisedPriceMax = that.$box.formatSplit(v.revisedPriceMax, true);
          }

          if (
            v.anticipatedRent !== undefined &&
            JSON.stringify(v.anticipatedRent).indexOf(".") !== -1
          ) {
            v.anticipatedRent = that.$box.formatSplit(v.anticipatedRent, true);
          } else {
            v.anticipatedRent = that.$box.formatSplit(v.anticipatedRent, true);
          }

          if (
            v.anticipatedRentMax !== undefined &&
            JSON.stringify(v.anticipatedRentMax).indexOf(".") !== -1
          ) {
            v.anticipatedRentMax =
              v.anticipatedRentMax !== 0
                ? that.$box.formatSplit(v.anticipatedRentMax, true)
                : null;
          } else {
            v.anticipatedRentMax =
              v.anticipatedRentMax !== 0
                ? that.$box.formatSplit(v.anticipatedRentMax, true)
                : null;
          }

          if (v.status == "Reserved") {
            v.class = "grn";
          } else if (
            v.status == "Sold" ||
            v.status == "Unconditional" ||
            v.status == "Settled"
          ) {
            v.class = "prl";
            v.status = "Sold";
          }

          if (v.balcony === 0) {
            v.balcony = "N/A";
          }
          if (v.baths === 0) {
            v.baths = "Studio";
          }
          if (v.beds === 0) {
            v.beds = "N/A";
          }
          if (v.cars === 0) {
            v.cars = "N/A";
          }
          if (v.internal === 0) {
            v.internal = "N/A";
          }
          if (v.storage === "0" || v.storage === "" || v.storage === null) {
            v.storage = "N/A";
          }
          if (v.anticipatedRent === 0) {
            v.anticipatedRent = "N/A";
          }
          if (v.revisedPrice === 0) {
            v.revisedPrice = "N/A";
          }
          if (v.total === 0) {
            v.total = "N/A";
          }
        });
        that.list = res.data.data;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 8902 ||
        res.data.code == 8901
      ) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    }
  },
  computed: {
    showFeesColumn() {
      return this.propsData.some(row => row.titleType !== "Torrens");
    }
  }
};
</script>

<template>
  <div id="top" class="out">
    <div class="title clear">
      <div class="apt">
        {{ propsProerty == landOnly ? "Lot Number" : "Residence" }}
      </div>
      <div class="status">Stamp Duty</div>
      <div class="pri">Council Rates (qtr)</div>
    </div>
    <div v-if="!loading" class="lst">
      <div v-if="propsData && propsData[0]">
        <div
          v-for="(item, index) in this.list"
          :key="item.a"
          :class="item.class"
          class="box"
        >
          <div
            :class="{ border: index == propsData.length - 1 || item.unfold }"
            class="line"
          >
            <div class="inn apt">{{ item.apt }}</div>
            <div class="inn status">
              {{
                item.stampDuty ? "$" + numberWithCommas(item.stampDuty) : "TBA"
              }}
            </div>
            <div class="inn pri">
              {{
                item.councilRates
                  ? "$" + numberWithCommas(item.councilRates)
                  : "TBA"
              }}
            </div>
            <div
              :class="{ unfold: item.unfold }"
              class="inn arw"
              @click.stop="unfold(index)"
            ></div>
          </div>
          <div
            :class="{ hid: !item.unfold }"
            :style="{ marginBottom: item.unfold ? '.34rem' : '0' }"
            class="more"
          >
            <div class="top">
              <div class="tit clear">
                <div class="bed">Transfer Fee</div>
                <div class="bed">Property Title</div>
                <div v-if="showFeesColumn" class="bat">
                  Estimated Fees (qtr)
                </div>
              </div>
              <div class="cons">
                <div class="bed">
                  {{
                    item.lodgement
                      ? "$" + numberWithCommas(item.lodgement)
                      : "TBA"
                  }}
                </div>
                <div class="bed">
                  {{ item.titleType ? item.titleType : "TBA" }}
                </div>
                <div v-if="showFeesColumn" class="bat">
                  {{
                    item.strataFees
                      ? "$" + numberWithCommas(item.strataFees)
                      : "TBA"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        style="text-align:center;padding:1rem 0;font-size:.3rem;color:#3F3F46"
      >
        No data
      </div>
      <div
        style="text-align:center;padding:1rem 0;font-size:.25rem;color:#3F3F46"
      >
        Please note the above information is subject to change at any time. At
        the time of preparation every care was taken to ensure this information
        was correct. This information should be used for informative purposes
        only. Stamp duty and lodgement fee estimates were derived from
        calculators and all other fees are based on estimates per quarter. All
        figures are to be used as a guide only. All associated costs of buying a
        property should be discussed with your conveyancer or solicitor.
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.out {
  box-sizing: border-box;
  width: 99%;

  .title {
    width: 100%;
    margin-bottom: 0.24rem;
    font-size: 0.28rem;
    line-height: 0.34rem;
    color: #8c8c90;
    padding-top: 0.54rem;

    div {
      float: left;
      width: 13.58%;
      box-sizing: border-box;
      padding-left: 0.2rem;
    }

    .apt {
      width: 30%;
    }

    .status {
      width: 30%;
    }

    .pri {
      width: 40%;
    }
  }

  .lst {
    margin-bottom: 0.48rem;

    .box {
      width: 100%;
      border-right: 1px solid #dee3e0;
      cursor: pointer;

      .line {
        width: 100%;
        display: table;

        .inn {
          display: table-cell;
          line-height: 0.82rem;
          font-size: 0.28rem;
          color: #3f3f46;
          box-sizing: border-box;
          padding: 0 0.2rem;
          border-top: 1px solid #dee3e0;
          border-left: 1px solid #dee3e0;
          word-break: break-word;
        }

        .apt {
          width: 30%;
        }

        .status {
          width: 30%;
        }

        .pri {
          width: 32.31%;
        }

        .arw {
          width: 7.69%;
          cursor: pointer;
          position: relative;
        }

        .arw:after {
          content: "";
          display: block;
          width: 100%;
          height: 0.5rem;
          position: absolute;
          top: 0;
          left: 0;
          background-repeat: no-repeat;
          background-size: 0.26rem 0.14rem;
          background-position: center 0.3rem;
          background-image: url("../../assets/arrw.png");
          transition: all 0.3s;
        }

        .unfold:after {
          transform: rotate(180deg);
          top: 0.16rem;
        }
      }

      .more {
        border: 1px solid #dee3e0;
        border-top: none;
        border-right: none;
        box-sizing: border-box;
        width: 100%;

        .top {
          width: 100%;
          box-sizing: border-box;
          padding: 0.4rem 0.2rem 0 0.4rem;
          margin-bottom: 0.18rem;

          .tit {
            width: 100%;
            font-size: 0.24rem;
            color: #8c8c90;
            line-height: 0.3rem;

            div {
              width: 30%;
              float: left;
            }

            div:nth-child(1) {
              width: 30%;
            }

            div:nth-child(2) {
              width: 40%;
            }
          }

          .cons {
            width: 100%;
            font-size: 0.28rem;
            display: table;
            color: #3f3f46;

            div {
              width: 30%;
              display: table-cell;
              line-height: 0.82rem;
              box-sizing: border-box;
              padding-right: 0.1rem;
            }

            div:nth-child(1) {
              width: 30%;
            }

            div:nth-child(2) {
              width: 40%;
            }
          }
        }

        .mid {
          width: 100%;
          box-sizing: border-box;
          padding: 0 0.2rem 0 0.4rem;
          margin-bottom: 0.18rem;

          .tit {
            width: 100%;
            font-size: 0.24rem;
            color: #8c8c90;
            line-height: 0.3rem;

            div {
              width: 50%;
              float: left;
            }

            div:nth-child(2) {
              width: 50%;
            }
          }

          .cons {
            width: 100%;
            font-size: 0.28rem;
            display: table;
            color: #3f3f46;
            line-height: 0.82rem;
            box-sizing: border-box;
            padding-right: 0.1rem;

            div {
              width: 50%;
              float: left;
            }

            div:nth-child(2) {
              width: 50%;
            }
          }
        }

        .bot {
          width: 100%;
          box-sizing: border-box;
          padding: 0 0.2rem 0 0.4rem;
          margin-bottom: 0.18rem;

          .tit {
            width: 100%;
            font-size: 0.24rem;
            color: #8c8c90;
            line-height: 0.3rem;

            div {
              width: 22%;
              float: left;
            }

            div:nth-child(3) {
              width: 56%;
            }
          }

          .cons {
            width: 100%;
            font-size: 0.28rem;
            display: table;
            color: #3f3f46;
            line-height: 0.82rem;
            box-sizing: border-box;
            padding-right: 0.1rem;

            div {
              width: 22%;
              float: left;
            }

            div:nth-child(3) {
              width: 56%;
            }
          }
        }
      }

      .hid {
        height: 0;
        overflow: hidden;
        border: none;
      }
    }

    .grn {
      background: #ecfaf2;
    }

    .prl {
      background: #f1f1f1;
    }

    .border {
      border-bottom: 1px solid #dee3e0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/associatedFeeSection.vue